"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrainSignature = exports.ColumnSignature = void 0;
class ColumnSignature {
    static from(serialized) {
        return new ColumnSignature(serialized[1], serialized[0]);
    }
    constructor(name, sourceNodeId) {
        this.name = name.toLowerCase();
        this.sourceNodeId = sourceNodeId;
    }
    serialize() {
        return [this.sourceNodeId, this.name];
    }
    equals(other) {
        return this.name === other.name && this.sourceNodeId === other.sourceNodeId;
    }
}
exports.ColumnSignature = ColumnSignature;
class GrainSignature {
    static from(serialized) {
        return new GrainSignature(serialized[0], serialized[1], serialized[2]);
    }
    constructor(sourceName, name, nameOverride) {
        this.sourceName = sourceName && sourceName.toLowerCase();
        this.name = name;
        this.nameOverride = nameOverride;
    }
    serialize() {
        if (this.nameOverride)
            return [this.sourceName, this.name, this.nameOverride];
        return [this.sourceName, this.name];
    }
    equals(other) {
        return this.name === other.name && this.sourceName === other.sourceName;
    }
}
exports.GrainSignature = GrainSignature;
class DataSignature {
    containsColumn(column) {
        return !!this.columns.find(col => col.equals(column));
    }
    containsGrain(grain) {
        return !!this.grains.find(g => g.equals(grain));
    }
    isEqual(compareGraph) {
        let isEqual = true;
        if (this.columns.length !== compareGraph.columns.length) {
            isEqual = false;
        }
        else {
            this.columns.forEach((col, index) => {
                if (col.name !== compareGraph.columns[index].name) {
                    isEqual = false;
                }
            });
        }
        return isEqual;
    }
}
exports.default = DataSignature;
